import React from 'react';

import Wishlist from 'src/components/Wishlist';

import { getHeaderTitle } from '../../../../utils/viewUtils';

import type { PropsFromRedux } from '.';
import styles from './header.module.css';

const Header = ({
  path,
  price,
  isHotelOnly,
  isWishlistAvailable,
  packageId,
}: PropsFromRedux) => {
  const title = getHeaderTitle(path, isHotelOnly);

  return title ? (
    <div className={styles.container}>
      <p className={styles.title}>{title}</p>
      {isWishlistAvailable && (
        <Wishlist
          className={styles.wishlist}
          price={price}
          type="package"
          wishlistIdentifier={packageId}
          isCheckoutPage
        />
      )}
    </div>
  ) : null;
};

export default Header;
